import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface InvitationLinkParams {
  name?: string;
  redirect?: string;
  tags?: string[];
}

type InvitationLinkFieldKey = keyof InvitationLinkParams;

interface InvitationLinkFieldConfig {
  defaultValue?: string;
  label: string;
  type: "string" | "array";
}

interface InvitationLinkCardProps {
  params: InvitationLinkParams;
  url: string;
}

export const InvitationLinkCard = ({
  params,
  url,
}: InvitationLinkCardProps) => {
  const INVITATION_LINK_FIELDS: Record<
    InvitationLinkFieldKey,
    InvitationLinkFieldConfig
  > = {
    name: {
      label: t("settings.invite_members.details_tab.member_details.name"),
      type: "string",
    },
    tags: {
      label: t("member_tags.form.tags", { defaultValue: "Tags" }),
      type: "array",
    },
    redirect: {
      label: t("settings.invite_members.details_tab.member_details.redirect", {
        defaultValue: "Redirect",
      }),
      type: "string",
      defaultValue: t("none", { defaultValue: "None" }),
    },
  };

  const fieldEntries = Object.entries(INVITATION_LINK_FIELDS) as Array<
    [InvitationLinkFieldKey, InvitationLinkFieldConfig]
  >;

  return (
    <PreviewCardLayout
      title={t("help_widget.copilot.preview_cards.invitation_link_card_title")}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {fieldEntries
          .map(([key, keyProps]) => {
            const value = params[key] ?? keyProps.defaultValue;

            if (value == null || value === "") return null;

            return (
              <li key={key} className="text-darkest !pb-0">
                <Typography.BodySm color="text-darkest">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(value, keyProps.type)}
                </Typography.BodySm>
              </li>
            );
          })
          .filter(Boolean)}
      </ul>
    </PreviewCardLayout>
  );
};
